(function () {
  var query = window.matchMedia('(prefers-reduced-motion: reduce)');

  function applyReducedMotion() {
    var videos = document.querySelectorAll('video[autoplay]');
    videos.forEach(function (video) {
      if (query.matches) {
        video.pause();
        video.removeAttribute('autoplay');
        video.dataset.reducedMotionPaused = 'true';
      } else if (video.dataset.reducedMotionPaused === 'true') {
        delete video.dataset.reducedMotionPaused;
        video.setAttribute('autoplay', '');
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(function () {});
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', applyReducedMotion);

  if (query.addEventListener) {
    query.addEventListener('change', applyReducedMotion);
  } else if (query.addListener) {
    query.addListener(applyReducedMotion);
  }
})();